import React from 'react';
import Modal from '../../../shared/components/ui/Modal';
import DeleteConfirmationModal from '../ui/DeleteConfirmationModal';
import ClonePaymentStages from '../forms/ClonePaymentStages';

const CommonPaymentModals = ({
  showChoiceModal,
  setShowChoiceModal,
  handleCreateNewPaymentStages,
  handleCreateBulkPaymentStages,
  showUnitwiseModal,
  setShowUnitwiseModal,
  selectedPaymentStage,
  units,
  setUnits,
  isSubmitting,
  handleUnitwiseMarkComplete,
  isCompletedPayment,
  setIsCompletedPayment,
  isCurrentDay,
  setIsCurrentDay,
  selectedDate,
  setSelectedDate,
  handleMarkupdate,
  isCompletingUnit,
  setIsCompletingUnit,
  canDelete,
  setCanDelete,
  resData,
  selectedIds,
  setSelectedIds,
  paymentdata,
  HandleDelete,
  isIndependent = false,
  showCloneModal,
  setShowCloneModal,
  projectId,
  handleCloneSuccess
}) => {
  return (
    <>
      {/* Choice Modal */}
      {showChoiceModal && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={`Select how you want to create payment stages`}
          onClose={() => setShowChoiceModal(false)}
          width={55}>
          <div className="flex flex-col gap-4 p-4">
            <div
              className={`grid grid-cols-1 ${isIndependent ? 'md:grid-cols-3' : 'md:grid-cols-2'} gap-4`}>
              <div
                className="bg-white border-2 border-gray-200 rounded-lg p-6 cursor-pointer hover:border-blue-500 hover:shadow-lg transition-all duration-200"
                onClick={() => {
                  handleCreateNewPaymentStages();
                  setShowChoiceModal(false);
                }}>
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg
                      className="w-8 h-8 text-blue-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                      />
                    </svg>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">Create Single</h3>
                  <p className="text-sm text-gray-600">
                    Create one payment stage at a time with detailed configuration
                  </p>
                </div>
              </div>

              <div
                className="bg-white border-2 border-gray-200 rounded-lg p-6 cursor-pointer hover:border-green-500 hover:shadow-lg transition-all duration-200"
                onClick={() => {
                  handleCreateBulkPaymentStages();
                  setShowChoiceModal(false);
                }}>
                <div className="text-center">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg
                      className="w-8 h-8 text-green-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                      />
                    </svg>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">Create Bulk</h3>
                  <p className="text-sm text-gray-600">
                    Create multiple payment stages at once for efficiency
                  </p>
                </div>
              </div>

              {isIndependent && (
                <div
                  className="bg-white border-2 border-gray-200 rounded-lg p-6 cursor-pointer hover:border-purple-500 hover:shadow-lg transition-all duration-200"
                  onClick={() => {
                    setShowCloneModal(true);
                    setShowChoiceModal(false);
                  }}>
                  <div className="text-center">
                    <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <svg
                        className="w-8 h-8 text-purple-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24">
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">Clone</h3>
                    <p className="text-sm text-gray-600">Clone stages of a unit to another units</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal>
      )}

      {/* Unitwise Modal */}
      {showUnitwiseModal && selectedPaymentStage && (
        <Modal
          isDirty={false}
          confirmOnClose={false}
          name={`Mark Complete: ${selectedPaymentStage.name} (${selectedPaymentStage.percentage}%)`}
          onClose={() => {
            setShowUnitwiseModal(false);
            setUnits([]);
          }}
          width={70}>
          <div className="flex flex-col gap-4 p-4 max-h-[550px] overflow-y-auto">
            <div className="bg-blue-50 p-4 rounded-lg mb-4">
              <p className="text-sm text-gray-600">
                <strong>Total Units:</strong> {units.length}
              </p>
            </div>

            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border px-4 py-2 text-left">Unit Name</th>
                  <th className="border px-4 py-2 text-left">Status</th>
                  <th className="border px-4 py-2 text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {units?.map((unit) => (
                  <tr key={unit.id} className="border-b hover:bg-gray-50">
                    <td className="border px-4 py-3">{unit.unit?.unitName || `Unit ${unit.id}`}</td>
                    <td className="border px-4 py-3">
                      <span
                        className={`px-2 py-1 rounded text-sm ${
                          unit.is_completed
                            ? 'bg-green-100 text-green-800'
                            : 'bg-yellow-100 text-yellow-800'
                        }`}>
                        {unit.is_completed ? 'Completed' : 'Pending'}
                      </span>
                    </td>
                    <td className="border px-4 py-3 text-center">
                      <button
                        onClick={() => handleUnitwiseMarkComplete(unit.id)}
                        disabled={isSubmitting || unit.is_completed}
                        className={`px-4 py-2 rounded text-sm ${
                          unit.is_completed
                            ? 'bg-gray-300 text-gray-600 cursor-not-allowed'
                            : 'bg-blue-500 text-white hover:bg-blue-600'
                        }`}>
                        {unit.is_completed ? 'Completed' : 'Mark as Complete'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="flex justify-end mt-4">
              <button
                className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                onClick={() => {
                  setShowUnitwiseModal(false);
                  setUnits([]);
                }}>
                Close
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* Completion Modal */}
      {isCompletedPayment && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          name={''}
          width={55}
          onClose={() => setIsCompletedPayment(false)}>
          <div className="z-50">
            <div className="flex justify-center mb-8 text-xl font-semibold">
              <p>Do you want to mark this Completed ?</p>
            </div>
            <div className="flex justify-center gap-6 mb-6">
              <div className="flex items-center gap-2">
                <input
                  type="radio"
                  id="currentDay"
                  checked={isCurrentDay}
                  onChange={() => setIsCurrentDay(true)}
                  className="form-radio h-4 w-4"
                />
                <label htmlFor="currentDay">Current Day</label>
              </div>
              <div className="flex items-center gap-2">
                <input
                  type="radio"
                  id="selectDate"
                  checked={!isCurrentDay}
                  onChange={() => setIsCurrentDay(false)}
                  className="form-radio h-4 w-4"
                />
                <label htmlFor="selectDate">Select Date</label>
              </div>
            </div>
            {!isCurrentDay && (
              <div className="flex justify-center mb-6">
                <input
                  type="date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  className="border rounded px-3 py-2"
                  max={new Date().toISOString().split('T')[0]}
                />
              </div>
            )}
            <div className="flex gap-8 justify-center">
              <button
                className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                onClick={() => {
                  setIsCompletedPayment(false);
                  setSelectedDate('');
                  setIsCurrentDay(true);
                  setIsCompletingUnit(false);
                }}>
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-gray-300"
                onClick={handleMarkupdate}
                disabled={!isCurrentDay && !selectedDate}>
                Confirm
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* Delete Modals */}
      {canDelete === 'no' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={`Cannot delete '${resData?.name || 'this payment stage'}'`}
          onClose={() => setCanDelete(null)}
          width={45}>
          {Array.isArray(resData?.reason) && resData.reason.length > 0 ? (
            <div className="flex flex-col justify-center align-center ">
              <p className="text-center">
                Looks like this payment stage has dependencies, please delete following lands and
                projects to proceed
              </p>
              <div className="flex justify-start, align-middle flex-wrap bg-[#f5f7f8] p-2 rounded-[5px] mt-4">
                {resData &&
                  resData.reason?.map((r, index) => (
                    <span className="mt-[2px] mr-[4px] text-[#535353]" key={index}>
                      {index + 1}.{r}
                      {index < resData.reason.length - 1 ? ', ' : ''}
                    </span>
                  ))}
              </div>
            </div>
          ) : (
            <div className="flex flex-col justify-center align-center ">
              <p className="text-center">
                {typeof resData?.reason === 'string' && resData.reason
                  ? resData.reason
                  : 'Payment is already completed'}
              </p>
            </div>
          )}
        </Modal>
      )}

      {canDelete === 'yes' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={'Confirmation'}
          onClose={() => {
            setCanDelete(null);
            setSelectedIds([]);
          }}
          width={45}>
          <DeleteConfirmationModal
            name={resData.name}
            title={'payment stage'}
            onClose={() => setCanDelete(null)}
            data={paymentdata}
            type={isIndependent ? 'independentPaymentStage' : 'paymentStage'}
            setCanDelete={setCanDelete}
            onDeleteClick={HandleDelete}
            setSelectedIds={setSelectedIds}
            selectedIds={selectedIds}
          />
        </Modal>
      )}

      {/* Clone Payment Stages Modal */}
      {showCloneModal && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          name={'Clone Payment Stages'}
          onClose={() => setShowCloneModal(false)}
          width={55}>
          <ClonePaymentStages
            projectId={projectId}
            onClose={() => setShowCloneModal(false)}
            onSuccess={handleCloneSuccess}
            isSubmitting={isSubmitting}
          />
        </Modal>
      )}
    </>
  );
};

export default CommonPaymentModals;
